module.exports = __webpack_public_path__ + "public/viewMessage/sendIcon.svg?0342b1ea";